import React, { FC } from 'react';
import { useFormContext } from 'react-hook-form';

interface Props {
	name: string;
	label: string;
	onLabel: string;
	offLabel: string;
	editable: boolean;
	edit: boolean;
	onChange?: () => void;
}

export const SwitchField: FC<Props> = ({ name, label, onLabel, offLabel, editable, edit, onChange }) => {
	const { register } = useFormContext();

	return (
		<div className={`form_row ${!(editable && edit) ? 'read_only' : ''}`}>
			<label htmlFor={name} className="input_label col-3">
				{label}
			</label>
			<label
				className={`switch on_off col_6 margin_top_12 margin_bottom_12 ${editable ? '' : ' disabled'}`}
				htmlFor={name}
			>
				<input
					className="switch_mark"
					id={name}
					name={name}
					type="checkbox"
					ref={register}
					disabled={!editable || !edit}
					onChange={onChange}
				/>
				<span className="slider"></span>
				<span className="checkbox_label">
					<span className="on_label flex_justify_end">{onLabel}</span>
					<span className="off_label flex_justify_end">{offLabel}</span>
				</span>
			</label>
		</div>
	);
};
